import React from "react"
import SideNav from "components/SideNav"
import styles from "./styles.scss"
import { getCategories, selectCategoriesAsArray } from "data/categories"
import { getCounties, selectCountiesAsArray } from "data/counties"
import { getCompany, selectCompany, updateCompany } from "data/companies"
import { connect } from "react-redux"
import CompanyForm from "components/CompanyForm"
import AdminHeader from "../../components/AdminHeader"
import { getBase64 } from "helpers"

class CompanyEdit extends React.Component {
  constructor(props) {
    super(props)

    const { id } = props.match.params
    id && props.getCompany(id)

    props.getCategories()
    props.getCounties()
  }
  handleSubmit = values => {
    const companyCategories = values.companyCategories.map(category => ({
      categoryId: category.value,
    }))

    const companyCounties = values.companyCounties.map(county => ({
      countyId: county.value,
    }))

    let newCompany = {
      name: values.companyName,
      phone: values.phone,
      email: values.email,
      companyCategories,
      companyCounties,
    }

    const { updateCompany, match } = this.props
    values.companyLogo
      ? getBase64(values.companyLogo["0"]).then(data => {
          var bindata = data.split(",")[1]
          newCompany = { ...newCompany, image: bindata }
          updateCompany(match.params.id, newCompany)
        })
      : updateCompany(match.params.id, newCompany)
  }

  getInitialValues = () => {
    const { company } = this.props

    return {
      companyName: company.name,
      phone: company.phone,
      email: company.email,
      companyCategories: company.companyCategories.map(
        companyCategory => ({
          value: companyCategory.categoryId,
          label: companyCategory.name,
        })
      ),
      companyCounties: company.companyCounties.map(companyCounty => ({
        value: companyCounty.countyId,
        label: companyCounty.name,
      })),
    }
  }

  render() {
    const { company, categories, counties } = this.props
    return (
      <div className={styles.container}>
        <div className={styles.mainContent}>
          <AdminHeader />
          <div className={styles.companyFormWrapper}>
            <SideNav type="companies" />
            <div className={styles.companyForm}>
              <h2>Uppdatera företag</h2>
              {company && (
                <CompanyForm
                  company={company}
                  categories={categories}
                  counties={counties}
                  onSubmit={this.handleSubmit}
                  submitText="Spara"
                  initialValues={this.getInitialValues()}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  categories: selectCategoriesAsArray(state, ownProps),
  counties: selectCountiesAsArray(state, ownProps),
  company: selectCompany(state, ownProps),
})

export default connect(
  mapStateToProps,
  {
    getCategories,
    getCounties,
    updateCompany,
    getCompany,
  }
)(CompanyEdit)



// WEBPACK FOOTER //
// src/pages/Admin/Companies/CompanyEdit/index.jsx